module.exports = __webpack_public_path__ + "media/images/social-share-button/linkedin-f321bca10c27a66936f855b2050bdae0.svg";